var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",class:_vm.additionalClass,attrs:{"role":"main"}},[(_vm.title)?_c('foobarz-header',{attrs:{"title":_vm.title}}):_vm._e(),_c('div',{staticClass:"main__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }